import App from 'app/app.js';

var MasterSubjectUserProfileXrefStatusConstants = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
  DELETED: 'DELETED',
  PRIVACY: 'PRIVACY',
  VERIFY: 'VERIFY',
  VERIFIED: 'VERIFIED'
};

App.constant('MasterSubjectUserProfileXrefStatusConstants', MasterSubjectUserProfileXrefStatusConstants);
